function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44.883px",
    height: "28.855px",
    viewBox: "0 0 44.883 28.855",
    style: {
      enableBackground: "new 0 0 44.883 28.855"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.8311,
    y1: -1.3892,
    x2: -4.0687,
    y2: 45.5106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M34.568,28.855H9.312c-0.88,0-1.755-0.142-2.6-0.42C2.781,27.255,0,23.515,0,19.355 c0-5.157,4.131-9.367,9.258-9.497C10.372,4.262,15.361,0,21.24,0c5.003,0,9.385,2.992,11.258,7.483 c0.542-0.085,1.088-0.128,1.635-0.128c5.928,0,10.75,4.822,10.75,10.75c0,4.7-2.999,8.807-7.468,10.237 C36.491,28.683,35.534,28.855,34.568,28.855L34.568,28.855z M9.5,13.855c-3.032,0-5.5,2.468-5.5,5.5 c0,2.407,1.609,4.573,3.914,5.266c0.491,0.161,0.944,0.234,1.398,0.234h25.256c0.502,0,1.004-0.093,1.492-0.276l0.103-0.036 c2.823-0.888,4.72-3.476,4.72-6.438c0-3.722-3.028-6.75-6.75-6.75c-0.765,0-1.531,0.136-2.278,0.404l-2.11,0.759l-0.514-2.183 C28.354,6.605,25.067,4,21.24,4c-4.438,0-8.123,3.612-8.213,8.053l-0.05,2.402l-2.354-0.484C10.253,13.895,9.875,13.855,9.5,13.855 L9.5,13.855z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.d4dc80647c536fae19350a9edcdd28be.svg";
export { ForwardRef as ReactComponent };